// jQuery
import jQuery from 'jquery';
global.jQuery = global.$ = jQuery;

require('jquery-migrate');
require('jQuery-QueryBuilder');
